import { initializeApp } from "firebase/app"
import { getStorage } from "firebase/storage"

/**
 * Configuration Firebase
 * Remplace ces valeurs par celles de ton projet Firebase
 */
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
}

// Vérification que les variables sont bien chargées
if (!firebaseConfig.apiKey) {
  console.error("❌ Firebase API Key manquante dans .env")
  console.error("Vérifie que ton fichier .env contient REACT_APP_FIREBASE_API_KEY")
}

if (!firebaseConfig.storageBucket) {
  console.error("❌ Firebase Storage Bucket manquant dans .env")
  console.error(
    "Vérifie que ton fichier .env contient REACT_APP_FIREBASE_STORAGE_BUCKET"
  )
}

// Initialisation de Firebase
let app
try {
  app = initializeApp(firebaseConfig)
  console.log("✅ Firebase initialisé avec succès")
} catch (error) {
  console.error("❌ Erreur initialisation Firebase:", error)
  throw error
}

// Initialisation de Storage
const storage = getStorage(app)

export { app, storage }
export default app
